import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getBanquetBySlug, banquets } from '../data/banquets';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { KeyDetailsBlock } from '../components/KeyDetailsBlock';
import { ImageGallery } from '../components/ImageGallery';
import { RelatedPages } from '../components/RelatedPages';
import { EnquiryForm } from '../components/EnquiryForm';
export function BanquetDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const venue = slug ? getBanquetBySlug(slug) : undefined;
  if (!venue) return <Navigate to="/banquets" replace data-id="element-587" />;
  const otherVenues = banquets.filter(b => b.id !== venue.id).slice(0, 3).map(b => ({
    title: b.name,
    image: b.image,
    link: `/banquets/${b.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-588">
      <PageBanner title={venue.name} eyebrow="Event Venues" image={venue.image} data-id="element-589" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-590">
        <Breadcrumbs items={[{
        label: 'Banquets & Events',
        path: '/banquets'
      }, {
        label: venue.name
      }]} data-id="element-591" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-8" data-id="element-592">
          <div className="lg:col-span-2 space-y-12" data-id="element-593">
            <section data-id="element-594">
              <h2 className="text-3xl mb-6" data-id="element-595">Overview</h2>
              <p className="text-lg text-club-ink/80 leading-relaxed" data-id="element-596">
                {venue.longDesc}
              </p>
            </section>

            <section data-id="element-597">
              <h2 className="text-3xl mb-6" data-id="element-598">Gallery</h2>
              <ImageGallery images={venue.images} data-id="element-599" />
            </section>

            <section id="enquire" data-id="element-600">
              <EnquiryForm variant="banquet" title={`Enquire about ${venue.name}`} data-id="element-601" />
            </section>
          </div>

          <div className="space-y-8" data-id="element-602">
            <KeyDetailsBlock details={venue.keyDetails} data-id="element-603" />

            <div className="bg-club-canvasAlt p-8 border border-club-border rounded-sm text-center" data-id="element-604">
              <h3 className="font-serif text-2xl mb-4 text-club-green" data-id="element-605">
                Event Planning
              </h3>
              <p className="text-sm text-club-ink/70 mb-6" data-id="element-606">
                Our dedicated events team is here to help you plan every detail
                of your special occasion.
              </p>
              <a href="#enquire" className="btn-secondary w-full block" data-id="element-607">
                Request Proposal
              </a>
            </div>
          </div>
        </div>

        <RelatedPages title="Other Venues" pages={otherVenues} data-id="element-608" />
      </div>
    </div>;
}